<!-- Test-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Test Navigation Root</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- URL Parameters Test Card -->
    <cs-card>
      <cs-card-header>URL Parameters Test</cs-card-header>
      <cs-card-content>
        <cs-item-list>
          <cs-item>
            <cs-label>Current URL:</cs-label>
            <cs-label class="mono">{{ currentUrl }}</cs-label>
          </cs-item>
          <cs-item vertical>
            <cs-label>Param 1:</cs-label>
            <cs-input
              [(value)]="param1Value"
              (valueChange)="handleParamChange()"
              [placeholder]="'Enter value for param1' | untranslated"
              data-test="param1-input">
            </cs-input>
          </cs-item>
          <cs-item vertical>
            <cs-label>Param 2:</cs-label>
            <cs-input
              [(value)]="param2Value"
              (valueChange)="handleParamChange()"
              [placeholder]="'Enter value for param2' | untranslated"
              data-test="param2-input">
            </cs-input>
          </cs-item>
          <cs-item vertical>
            <cs-label>Param 3:</cs-label>
            <cs-input
              [(value)]="param3Value"
              (valueChange)="handleParamChange()"
              [placeholder]="'Enter value for param3' | untranslated"
              data-test="param3-input">
            </cs-input>
          </cs-item>
          <cs-item>
            <cs-button item-right small secondary
              (click)="navigateToChild()"
              icon="beaker"
              [label]="'Go to Child Page (with params)' | untranslated"
              data-test="nav-to-child">
            </cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right small secondary
              (click)="navigateToChildUpdatingParamsWhileOpening()"
              icon="beaker"
              [label]="'Go to Child, Changing Param 1 While It Opens' | untranslated"
              data-test="nav-to-child-updating-params">
            </cs-button>
          </cs-item>
        </cs-item-list>
      </cs-card-content>
    </cs-card>
  </cs-card-list>

</cs-content>
